const APP_URL = 'https://pantryioapp.com'

export function buildInviteUrl(referralCode: string): string {
  return `${APP_URL}/sign-up?ref=${encodeURIComponent(referralCode)}`
}

export function buildInviteMessage(referralCode: string, firstName?: string | null): string {
  const inviter = firstName ? `${firstName}'s ` : ''
  return `Join me on Pantry — track what's in your kitchen and stop wasting groceries. ${inviter}invite link: ${buildInviteUrl(referralCode)}`
}
